// extracted by mini-css-extract-plugin
export default {"webicon":"IconWeb_webicon__kkWxP"};